exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".videoWording{margin:0;position:absolute;top:50vh;font-size:50px;left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);color:#fff}", "", {"version":3,"sources":["/Users/jmac/Downloads/Proj/282021/HT2021/HT2021/hullthread version 2.0/tests/src/components/VideoBackground/vidbackground.css"],"names":[],"mappings":"AAAA,cACI,SAAU,AACV,kBAAmB,AACnB,SAAU,AACV,eAAgB,AAChB,SAAU,AACV,uCAAyC,AACrC,mCAAqC,AACjC,+BAAiC,AACzC,UAAa,CAChB","file":"vidbackground.css","sourcesContent":[".videoWording {\r\n    margin: 0;\r\n    position: absolute;\r\n    top: 50vh;\r\n    font-size: 50px;\r\n    left: 50%;\r\n    -webkit-transform: translate(-50%, -50%);\r\n        -ms-transform: translate(-50%, -50%);\r\n            transform: translate(-50%, -50%);\r\n    color: white;\r\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/VideoBackground/vidbackground.css
// module id = 1325
// module chunks = 0 1 2 3 4 5 6 7